var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    New Document\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4072266,13.0830078 L11.1245118,13.0830078 L11.1245118,14.5830078 L4.4072266,14.5830078 L4.4072266,13.0830078 Z M4.4072266,9.25 L15.4072266,9.25 L15.4072266,10.75 L4.4072266,10.75 L4.4072266,9.25 Z M4.4072266,5.4169922 L15.4072266,5.4169922 L15.4072266,6.9169922 L4.4072266,6.9169922 L4.4072266,5.4169922 Z M15.3334961,0 L20,4.7011719 L20,11.0009766 L18.5,11.0009766 L18.5,5.3193359 L14.7084961,1.5 L1.5,1.5 L1.5,18.5 L11,18.5 L11,20 L0,20 L0,0 L15.3334961,0 Z M17.25,13 L17.25,15.75 L20,15.75 L20,17.25 L17.25,17.25 L17.25,20 L15.75,20 L15.75,17.25 L13,17.25 L13,15.75 L15.75,15.75 L15.75,13 L17.25,13 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDoc);
export default __webpack_public_path__ + "static/media/new-doc.34f75fa9c2d673fe391c06fea85f3b49.svg";
export { ForwardRef as ReactComponent };